<template>
  <v-app class="grey lighten-4">
    <vue-progress-bar></vue-progress-bar>
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <v-list>
        <v-tooltip lazy right>
          <v-list-tile @click="miniVariant = !miniVariant" slot="activator">
              <v-list-tile-action>
                <v-icon>{{ miniVariant ? 'chevron_right' : 'chevron_left' }}</v-icon>
              </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="collapse grey--text text--darken-1">Collapse</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <span>{{ miniVariant ? 'Expand' : 'Collapse' }}</span>
        </v-tooltip>
        <v-tooltip right lazy v-for="(item, i) in sideBarItems" :key="i">
          <v-list-tile
            value="true"
            slot="activator"
            ripple
            exact
            :to="item.link"
          >
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title" class="grey--text text--darken-1"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <span>{{ item.title }}</span>
        </v-tooltip>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      class="green darken-1"
      dark
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      
      <router-link tag="span" to="/" flat style="cursor: pointer">
        <v-avatar v-if="!this.$store.getters.GET_TOKEN">
            <img src="https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_64/site/logo" alt="ICS Logo">
        </v-avatar>
      </router-link>
      <v-toolbar-title v-text="title" v-if="!this.$store.getters.GET_TOKEN"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="body-1">
        <!-- <v-avatar size="42px">
          <img :src="getUserDetails.image" class="mr-3">
        </v-avatar> -->
        <div>{{ getUserDetails.name }}</div>
        <div style="font-weight: 300">{{ getUserDetails.role }}</div>
      </v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-slide-x-transition mode="out-in">
        <router-view/>
      </v-slide-x-transition>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; {{ new Date().getFullYear() }} Tesseract Tech Solutions</span>
    </v-footer>
  </v-app>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      miniVariant: true,
      title: 'Institute of Computer Studies'
    }
  },
  computed: {
    sideBarItems(){
      return this.$store.getters.GET_SIDEBAR_ITEMS
    },
    getUserDetails(){
      return this.$store.getters.GET_USER_DETAILS
    }
  },
  async created(){
    if(this.$store.getters.GET_TOKEN){
      try{
        let userData = await axios.get('/api/profile', { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
        let role = await axios.get('/api/auth/me/role', { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
        
        let { given_name, middle_name, family_name, user_id } = userData.data
        let { user_role } = role.data
        let userObject = { name: `${given_name} ${family_name}`, user_id }
        let userDetails = {}
        if(user_role === 0){
          userDetails = { ...userObject, role: 'Administrator' }
        } else if(user_role === 1){
          userDetails = { ...userObject, role: 'Instructor' }
        } else if(user_role === 2){
          userDetails = { ...userObject, role: 'Student' }
        }

        this.$store.commit('SET_USER_DETAILS', userDetails)
      }catch(e){

        console.log(e)
      }
        
    }
  },
  name: 'App'
}
</script>

<style scoped>
.collapse{
  color: #00E676;
}
</style>



// WEBPACK FOOTER //
// src/App.vue